import i18n from "@/i18n";

const routes = {
  path: "/tournament",
  name: i18n.t("menu.tournament.tournament"),
  component: () =>
    import(
      /* webpackChunkName: "tournament" */ "@/views/tournament/TournamentMain"
    ),
  children: [
    {
      path: "tournamentschedule",
      alias: "",
      name: "TournamentSchedule",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/TournamentSchedule"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("menu.tournament.tournament_schedule"),
        m_subtitle: i18n.t("menu.tournament.tournament_schedule"),
        menu_num: 2,
        sub_menu_num: 21,
        step: [
          i18n.t("menu.tournament.tournament"),
          i18n.t("menu.tournament.tournament_schedule"),
        ],
        location: "/tournament/tournamentschedule",
      },
    },
    {
      path: "tournamentscheduleview/:id",
      name: "TournamentScheduleView",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/TournamentScheduleView"
        ),
      children: [
        {
          path: "condition",
          alias: "",
          name: "Condition",
          component: () =>
            import(
              /* webpackChunkName: "tournament" */ "@/views/tournament/TournamentCondition"
            ),
          prop: true,
          meta: {
            layout: "DefaultLayout",
            wrapId: "sub",
            subtitle: i18n.t("menu.tournament.tournament_schedule"),
            m_subtitle: i18n.t("menu.tournament.tournament_schedule"),
            menu_num: 2,
            sub_menu_num: 21,
            step: [
              i18n.t("menu.tournament.tournament"),
              i18n.t("menu.tournament.tournament_schedule"),
            ],
            location: "/tournament/tournamentschedule",
          },
        },
        {
          path: "ranking",
          name: "Ranking",
          component: () =>
            import(
              /* webpackChunkName: "tournament" */ "@/views/tournament/TournamentRanking"
            ),
          prop: true,
          meta: {
            layout: "DefaultLayout",
            wrapId: "sub",
            subtitle: i18n.t("menu.tournament.tournament_schedule"),
            m_subtitle: i18n.t("menu.tournament.tournament_schedule"),
            menu_num: 2,
            sub_menu_num: 21,
            step: [
              i18n.t("menu.tournament.tournament"),
              i18n.t("menu.tournament.tournament_schedule"),
            ],
            location: "/tournament/tournamentschedule",
          },
        },
      ],
    },
    {
      path: "tournamentmember/:playerno",
      name: "TournamentMember",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/TournamentMember"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("menu.tournament.tournament_schedule"),
        m_subtitle: i18n.t("menu.tournament.tournament_schedule"),
        menu_num: 2,
        sub_menu_num: 21,
        step: [
          i18n.t("menu.tournament.tournament"),
          i18n.t("menu.tournament.tournament_schedule"),
        ],
        location: "/tournament/tournamentschedule",
      },
    },
    {
      path: "jointournament",
      name: "JoinTournament",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/JoinTournament"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("menu.tournament.tournament_information"),
        m_subtitle: i18n.t("menu.tournament.tournament_information"),
        menu_num: 2,
        sub_menu_num: 22,
        step: [
          i18n.t("menu.tournament.tournament"),
          i18n.t("menu.tournament.tournament_information"),
        ],
        location: "/tournament/jointournament",
      },
    },
  ],
};

export default routes;
